'use strict';
import angular from 'angular';
import $ from 'jquery';
import _ from 'lodash';

angular.module('integrations.ctrls', [])
    .controller('IntegrationsController', IntegrationsController)
    .controller('IntegrationsMappingsController', IntegrationsMappingsController)
    .controller('ConfigureImportController', ConfigureImportController)
    .controller('FileIntegrationController', FileIntegrationController)
    .controller('SalesforceIntegrationController', SalesforceIntegrationController)
    .controller('IntegrationActivityLogController', IntegrationActivityLogController)
    .controller('WebhookController', WebhookController)
    .controller('ActivityLogResultViewController', ActivityLogResultViewController);

IntegrationsController.$inject = ['$rootScope', '$scope', '$state', '$modal', '$ioAlert', 'ClusterService', 'IntegrationsService', 'ModalService', '$location', 'anchorSmoothScroll', '$timeout', 'FormService', 'ClientFactory'];

function IntegrationsController($rs, $scope, $state, $modal, $ioAlert, ClusterService, IntegrationsService, ModalService, $location, anchorSmoothScroll, $timeout, FormService) {
    $scope.addIntegration = addIntegration;
    $scope.exportIntegration = exportIntegration;
    $scope.deleteIntegration = deleteIntegration;
    $scope.addFileBased = addFileBased;
    $scope.addSalesforceIntegration = addSalesforceIntegration;
    $scope.toggleStatus = toggleStatus;
    $scope.integrations = [];
    $scope.lockedButton = false;
    $scope.templateTypes = [];
    $scope.nonIOUser = false;
    $scope.disableBtnAction = false;
    init();

    function addIntegration(data) {
        $scope.lockedButton = true;
        showIntegrationModal('integrationForm', data).result.then(function(formObj) {
            let webhookObj = null;
            if (!formObj.new && (formObj.typeId == "4" || formObj.typeId == "5")) {
                webhookObj = angular.copy(formObj.webhookObj);
                delete formObj.webhookObj;
            }
            IntegrationsService.integration(formObj.new ? 'POST' : 'PUT', formObj).then(function(data) {
                $scope.lockedButton = false;
                if (!data.hasOwnProperty('errors')) {
                    if (formObj.new) {
                        $scope.integrations.push(data.integration);
                        $ioAlert.show('', 'Integration added successfully', 'success');
                        switch (parseInt(data.integration.type_id)) {
                            case 3:
                                $state.go('integrations.configure', {
                                    "id": data.integration.id,
                                    "type": 'salesforce',
                                    "isSalesForce": true
                                });
                                break;
                            case 4:
                                $state.go('integrations.webhook', {
                                    "id": data.integration.id,
                                    "webhookType": 'publish',
                                    "integration": data.integration
                                });
                                break;
                            case 5:
                                $state.go('integrations.webhook', {
                                    "id": data.integration.id,
                                    "webhookType": 'consume',
                                    "integration": data.integration
                                });
                                break;
                        }
                    } else {
                        if (webhookObj && (data.integration.type_id == 4 || data.integration.type_id == 5)) {
                            webhookObj.name = data.integration.name;
                            updateWebhookName(data.integration.id, webhookObj);
                        }
                        $scope.integrations = updateIntegrationsList($scope.integrations, data);
                        $ioAlert.show('', 'Integration updated successfully', 'success');
                    }

                } else {
                    $ioAlert.show('Error!', JSON.stringify(data.errors), 'error');
                }
            }, function(error) {
                $scope.lockedButton = false;
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            })
        }, function(cancel) {
            $scope.lockedButton = false;
        })
    }

    function exportIntegration(data) {
        IntegrationsService.exportIntegration(data).then(function(response) {
            if (!response.hasOwnProperty('errors')) {
                let csvString = response;
                let a = $('<a/>', {
                    style: 'display:none',
                    href: 'data:application/octet-stream;base64,' + btoa(unescape(encodeURIComponent(csvString))),
                    download: 'integration_' + data.id + '.csv'
                }).appendTo('body');
                a[0].click();
                a.remove();
                $ioAlert.show('', 'File exported successfully', 'success');
            } else {
                for (var i = 0, len = response.errors.length; i < len; i++) {
                    $ioAlert.show('ERROR!', response.errors[i], 'error');
                }
                console.log(response.errors);
            }

        }, function(error) {
            $scope.lockedButton = false;
            $ioAlert.show('Error!', 'Error exporting integration ' + data.id + ': ' + error, 'error');
        });
    }

    function deleteIntegration(data) {
        if (data.type_id == '0') {
            data.type_id = '1';
        }
        showIntegrationModal('deleteIntegration', data).result.then(function(formObj) {
            IntegrationsService.integration('DELETE', removeHashKey(data)).then(function(data) {
                if (!data.hasOwnProperty('errors')) {
                    $scope.integrations = updateIntegrationsList($scope.integrations, data);
                    $ioAlert.show('', 'Service connection deleted successfully', 'success');
                } else {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                }

            }, function(error) {
                $scope.lockedButton = false;
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }, function(cancel) {
            $scope.lockedButton = false;
        })
    }

    function updateWebhookName(integrationId, webhookObj) {
        var obj = {
            "id": parseInt(webhookObj.id),
            "name": webhookObj.name,
            "integrationId": integrationId,
            "additionalInfo": {
                "url": webhookObj.url,
                "method_type": webhookObj.methodType,
                "type": webhookObj.authType,
                "auth_info": webhookObj.authInfo
            }
        };
        obj.additionalInfo = JSON.stringify(obj.additionalInfo);
        IntegrationsService.updateWebhook(obj).then(function(data) {
            if (data && data.id) {
                //$ioAlert.show('', 'Webhook Subscription updated successfully', 'success');
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
    /*
     * Add for file based integration type
     */
    function addFileBased(data) {
        $state.go('integrations.fileIntegration');
    }

    function toggleStatus(data) {
        var obj = {
            "id": data.id,
            "active": data.active
        };
        IntegrationsService.toggleStatus(obj).then(function(data) {
            if (data) {
                $ioAlert.show('', 'Status updated successfully.', 'success');
            }
        }, function(error) {
            $scope.lockedButton = false;
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    function addSalesforceIntegration(data) {
        $state.go('integrations.salesforceIntegration');
    }

    function getIntegrations() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Integrations";
        $scope.isPageLoading = true;
        IntegrationsService.integrations().then(function(data) {
            $scope.integrations = data[0].integrations;
            if ($scope.nonIOUser) {
                var temp = [];
                _.each($scope.integrations, function(integration) {
                    if (integration.type_id != '4') {
                        temp.push(integration);
                    }
                });
                $scope.integrations = temp;
            }
            $scope.isPageLoading = false;
            $rs.loadingInProgress = false;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $scope.isPageLoading = false;
            $rs.loadingInProgress = false;
        });
    }

    function getIntegrationTemplateTypes() {
        IntegrationsService.xrefTypes().then(function(data) {
            if (data[0].integrationXrefs) {
                //$scope.templateTypes = data[0].integrationXrefs;
                $scope.templateTypes = _.remove(data[0].integrationXrefs, function(n) {
                    return n.name;
                });
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    function removeHashKey(data) {
        if (data && data.hasOwnProperty('$$hashKey')) {
            delete data.$$hashKey;
        }
        return data;
    }

    function showIntegrationModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, data ? { data: { '$scope': $scope, '$state': $state, 'data': data } } : { data: { '$scope': $scope, '$state': $state } }));
    }

    function updateIntegrationsList(integrations, data) {
        var updatedIntegrations = [];
        integrations.forEach(function(integration) {
            if (integration.id !== (data.integration ? data.integration.id : data.id)) {
                updatedIntegrations.push(integration);
            }
        });
        $scope.lockedButton = false;
        if (data.integration) updatedIntegrations.push(data.integration);
        return updatedIntegrations;
    }

    $scope.cloneIntegrationTemplate = function() {
        $modal.open(
            ModalService.returnModalType('cloneIntegrationTemplate', {
                data: {
                    templateTypes: $scope.templateTypes,
                    clusters: ClusterService.clusters,
                    integrations: $scope.integrations
                }
            })
        ).result.then(function() {

        });
    };

    $scope.importIntegration = function() {
        if (!$scope.disableBtnAction && $scope.uploadMedia.file && $scope.uploadMedia.file.length) {
            IntegrationsService.importIntegration($scope.uploadMedia.file).then(function (data) {
                if (!data.data.result.hasOwnProperty('errors')) {
                    $ioAlert.show('', 'Integration imported successfully', 'success');
                    getIntegrations();
                } else {
                    for (var i = 0, len = data.data.result.errors.length; i < len; i++) {
                        $ioAlert.show('ERROR!', data.data.result.errors[i], 'error');
                    }
                    console.log(data.data.result.errors);
                }

            }, function (error) {
                $scope.lockedButton = false;
                $ioAlert.show('Error!', 'Error importing integration: ' + error, 'error');
            });
        }
    };

    /*
     * Handle get instance lock configuration
     */
    function getInstanceLockConfig() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    function adjustStickyHeader() {
        var parentWidth = $(".nav-content").width();
        $("#header").width(parentWidth);
        var childHeight = $("#header").height();
        $(".nav-content").height(childHeight);
    }

    $(window).resize(
        function() {
            adjustStickyHeader();
        }
    )

    function init() {
        if ($rs.userRole) {
            ClusterService.initCluster($rs.userRole, 'hidden');
        } else if ($rs.user.isIOAuthorized === false) {
            $scope.nonIOUser = true;
        }
        getIntegrations();
        getIntegrationTemplateTypes();
        getInstanceLockConfig();
        adjustStickyHeader();
    }
}

IntegrationsMappingsController.$inject = ['$rootScope', '$scope', '$state', '$modal', '$ioAlert', 'ClusterService', 'FormService', 'ProductService', 'ModalService', 'IntegrationsService', 'LoadingState', '$location', 'anchorSmoothScroll', '$timeout', 'UserService', 'ioServiceConnectionsService', 'ClientFactory', '$q'];

function IntegrationsMappingsController($rs, $scope, $state, $modal, $ioAlert, ClusterService, FormService, ProductService, ModalService, IntegrationsService, LoadingState, $location, anchorSmoothScroll, $timeout, UserService, ConnectionService, ClientFactory, $q) {

    var self = this;
    $scope.mappings = [];
    $scope.loadingState = LoadingState.FETCHING;
    $scope.lockedButton = true;
    $scope.integrationId = $state.params.id;
    var salesforceObj, fileCredentailObj, configureId, isNewImport;
    var questions = {};
    $scope.hasClient = false;
    $scope.nonIOUser = false;
    $scope.loadMappingForm = false;
    $scope.disableBtnAction = false;

    function showIntegrationModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, data ? { data: { '$scope': $scope, '$state': $state, 'data': data } } : { data: { '$scope': $scope, '$state': $state } }));
    }

    function showConnectionModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, data));
    }

    function getDataTypes() {
        FormService.getDataTypes().then(function(dataTypes) {
            $scope.dataTypes = dataTypes;
        }, function(error) {
            console.log("Error loading data types");
        });
    }

    function getLookupTypes() {
        ProductService.getLookupTypes().then(function() {}, function(error) { console.log("Error loading lookup types") });
    }

    function getIntegration() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Mappings";
        IntegrationsService.integration('GET', { id: $state.params.id }).then(function(integration) {
            $scope.integration = integration.integration;
            // UI is using bool, see integrations.directives.js
            $scope.isActive = parseInt($scope.integration.active) ? true : false;

            if (integration.integration.length !== 0) {
                IntegrationsService.xrefs(undefined, { integrationName: integration.integration.name }).then(function(xrefs) {
                    IntegrationsService.xrefTypes().then(function(types) {
                        $scope.xrefTypes = {};
                        types[0].integrationXrefs.forEach(function(type) {
                            $scope.xrefTypes[type.id] = type.name;
                        });
                        //$scope.lockedButton = true;
                        $scope.lockedButton = false;
                        _.each(xrefs.integrationXrefs, function(mapping) {
                            var typeName = $scope.xrefTypes[mapping.type_id];
                            mapping.type = { name: typeName, id: mapping.xref_value };
                            mapping.type_name = typeName.charAt(0).toUpperCase() + typeName.slice(1);
                            mapping.dtaTypes = $scope.dataTypes;
                            mapping.lookupTypes = ProductService.lookupTypes;
                            $scope.mappings.push(mapping);
                        });
                        _.each($scope.mappings, function(mapping) {
                            if (mapping.type_name == 'Client') {
                                $scope.hasClient = true;
                            }
                        });
                        if ($state.params.type == 'file') {
                            $scope.showCredentials = true;
                            if ($scope.integration && $scope.integration.service_connection_id) {
                                getFileCredentials($scope.integration.service_connection_id);
                            }
                        } else if ($state.params.type == 'salesforce') {
                            $scope.showCredentials = true;
                            if ($scope.integration && $scope.integration.service_connection_id) {
                                getSalesforceCredentials($scope.integration.service_connection_id);
                            } else {
                                // For backward Compatablity, Integration for which service connection id is not mapped
                                getCredentials(1);
                            }
                        }
                        //Call Imported Configuration only if Client type is not yet Created
                        if (!$scope.hasClient) {
                            getImporterConfig();
                        }
                        $rs.loadingInProgress = false;
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            } else {
                $rs.loadingInProgress = false;
                $state.go('integrations');
                //$ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            }
        }, function(error) {
            console.log("Error loading Integration");
        });
    }

    /*
     * Get Importer configuration
     */
    function getImporterConfig() {
        IntegrationsService.configurationForIntegration('GET', { 'integrationId': $state.params.id }).then(function(response) {
            if (response.importerConfiguration && response.importerConfiguration) {
                isNewImport = false;
                configureId = response.importerConfiguration.id;
                questions = response.importerConfiguration.configuration;
            } else {
                isNewImport = true;
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $state.go('integrations');
        });
    }

    /*
     * Get Credentials for Salesforce Type Integrations
     */
    function getSalesforceCredentials(id) {
        ConnectionService.getServiceConnection(id).then(function(response) {
            if (response && response.serviceConnection) {
                salesforceObj = response.serviceConnection;
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Could not get push services.', 'error');
        });
    }

    /*
     * For backward Compatablity, Integration for which service connection id is not mapped
     */
    function getCredentials(id) {
        ConnectionService.getConnectionsForService(id).then(function(response) {
            if (response && response.serviceConnections && response.serviceConnections.length) {
                salesforceObj = response.serviceConnections[0];
                updateServiceConnectionId(salesforceObj.id);
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Could not get push services.', 'error');
        });
    };

    function updateServiceConnectionId(id) {
        $scope.integration.service_connection_id = id;
        var integrationObj = {
            "id": $scope.integration.id,
            "name": $scope.integration.name,
            "typeId": $scope.integration.type_id,
            "clientOnly": $scope.integration.client_only,
            "serviceConnectionId": id
        };
        IntegrationsService.integration('PUT', integrationObj).then(function(data) {
            if (data.errors) {
                for (var i = 0, len = data.errors.length; i < len; i++) {
                    $ioAlert.show('Error', data.errors[i]);
                }
            }
        }, function(error) {
            console.log("Error updating integration");
        });
    }
    /*
     * Get credentials for file type integrations
     */
    function getFileCredentials(id) {
        ConnectionService.getServiceConnection(id).then(function(response) {
            if (response && response.serviceConnection) {
                fileCredentailObj = response.serviceConnection;
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Could not get push services.', 'error');
        });
    }

    function getMappingTemplates(mapping, isLoading) {
        var deferred = $q.defer();
        var typeName = $scope.xrefTypes[mapping.type_id];
        var templateObj = { integrationName: $scope.integration.name };
        $scope.currentMapping = mapping;
        if (parseInt(mapping.type_id) !== 3) {
            templateObj[typeName === 'Product' ? 'productId' : 'clusterId'] = mapping.xref_key;
        }

        if (isLoading === true) {
            mapping.disabled = true;
            IntegrationsService[typeName + 'IntegrationTemplates'](undefined, templateObj).then(function(templates) {
                //fetch the needed product options for those rows
                if (typeName === 'Product') {
                    FormService.getFlightFormFieldsForProduct(mapping.xref_value).then(function(flightFields) {
                        ProductService.getProductFields({"productId": mapping.xref_value}).then(function () {
                            //set the mapping references first so they are available when template rows get set and rendered

                            // distiguish product field id and flight field id
                            // we will aslo parse them during saveTemplate in integrations.directives.js
                            _.each(ProductService.productFields, function(productField) {
                                productField.id = String(productField.id) + 'l';
                            });
                            mapping.mapref = ProductService.productFields;
                            mapping.mapref = _.orderBy(mapping.mapref, (item) => item.field_name.toLowerCase());

                            if (flightFields && flightFields.length !== 0) {
                                _.each(flightFields, function(field) {
                                    field.id = String(field.id) + 'f';
                                    field.field_name += ' (Flight)';
                                });
                                mapping.mapref = mapping.mapref.concat(_.orderBy(flightFields, (item) => item.field_name.toLowerCase()));
                            }

                            //update the mapping with its template rows
                            mapping.templates = templates[typeName + 'Templates'];
                            if (mapping.templates && mapping.templates.length === 0) {
                                mapping.initialTemplate = true;
                            } else {
                                _.each(mapping.templates, function (template) {
                                    template.isRequired = template.required === "1";
                                    template.isFlightField = template.is_flight_field === "1";
                                    // distiguish product field id and flight field id
                                    template.field_id = template.isFlightField ?
                                                        String(template.field_id) + 'f' :
                                                        String(template.field_id) + 'l';
                                });
                            }
                            mapping.disabled = false;
                            deferred.resolve();
                        }, function (error) {
                            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                            deferred.reject();
                        })
                    }, function (error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                        deferred.reject();
                    })
                } else if (typeName === 'Order') {
                    FormService.getOrderFormFields(mapping.xref_value).then(function() {
                        mapping.mapref = FormService.formFields;
                        mapping.mapref = _.orderBy(mapping.mapref, (item) => item.field_name.toLowerCase());
                        //update the mapping with its template rows
                        mapping.templates = templates[typeName + 'Templates'];
                        if(mapping.templates && mapping.templates.length === 0) {
                            mapping.initialTemplate = true;
                        }
                        mapping.disabled = false;
                        deferred.resolve();
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                        deferred.reject();
                    });
                } else {
                    let columns = [
                        'company_name',
                        'first_name',
                        'last_name',
                        'default_reporting_profile_id',
                        'address_1',
                        'address_2',
                        'city',
                        'state',
                        'zip',
                        'country',
                        'phone',
                        'fax',
                        'website',
                        'client_category_id',
                        'has_light_logo',
                        'has_dark_logo',
                        'crm_id',
                        'billing_id',
                        'additional_details_1',
                        'additional_details_2',
                        'additional_details_3',
                        'report_language',
                        'reporting_status',
                        'enable_lead_management_module',
                        'account_manager_user_id',
                        'proposal_tool_id'
                    ];
                    if ($rs.user.availableModules.includes('io_tool')) {
                        columns.push('iotool_status');
                    }
                    ClientFactory.getColumns({
                        fields: columns.toString()
                    }).then(function(response) {
                        mapping.mapref = _.map(response.plain(), function(metadata) {
                            return _.pick(metadata, ['field', 'label']);
                        });
                        mapping.mapref = _.orderBy(mapping.mapref, (item) => item.label.toLowerCase());
                        mapping.templates = templates[typeName + 'Templates'];
                        if(mapping.templates && mapping.templates.length === 0) {
                            mapping.initialTemplate = true;
                        }
                        mapping.disabled = false;

                        // Add custom client form fields into existing mapping array
                        FormService.getClientFormFields().then(function(response) {
                            if (response.formFields) {
                                _.each(response.formFields, function(field) {
                                    if (!_.find(mapping.mapref, {field: field.field_name})) {
                                        let fieldEntry = {};
                                        fieldEntry.field = field.field_name;
                                        fieldEntry.label = field.display_name;
                                        mapping.mapref.push(fieldEntry);
                                    }
                                });
                                mapping.mapref = _.orderBy(mapping.mapref, (item) => item.label.toLowerCase());
                            }
                            deferred.resolve();
                        }, function(error) {
                            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                            $state.go('integrations');
                            deferred.reject();
                        });
                    });
                }
            });
        }
        return deferred.promise;
    }

    function addNewTemplateWhenClone(newMapping, sourceFieldName, newMappingFieldId, sourceTemplate) {
        var paramsObj = {};
        if (newMapping.type_name === 'Order') {
            paramsObj.clusterId = newMapping.xref_value;
        } else {
            paramsObj.productId = newMapping.xref_value;
        }
        paramsObj.required = sourceTemplate.isRequired ? 1 : 0;
        paramsObj.fieldId = newMappingFieldId;
        paramsObj.is_flight_field = sourceTemplate.isFlightField ? 1 : 0;
        paramsObj.integrationId = sourceTemplate.integration_id;
        paramsObj.datatype = sourceTemplate.datatype;
        paramsObj.parameter = sourceTemplate.parameter;

        IntegrationsService[newMapping.type_name + 'IntegrationTemplate']('POST', paramsObj).then(function(data) {
            if (!data.hasOwnProperty('errors')) {
                newMapping.templates.push(data[newMapping.type_name + 'IntegrationTemplate']);
                $ioAlert.show('', 'Mapping template successfully added.', 'success');
            } else {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        })
    }

    $scope.backToIntegrations = function() {
        if($scope.currentMapping) {
            $rs.$broadcast('LoadIntegrations', $scope.currentMapping);
        } else {
            $state.go('integrations');
        }
    }

    $scope.toggle = function(ev, mapping) {
        $(ev.target).parent().siblings(":last").slideToggle(200);
        if (mapping.isOpen === undefined || mapping.isOpen === false) {
            mapping.isOpen = true;
        } else {
            mapping.isOpen = false;
        }
        getMappingTemplates(mapping, mapping.isOpen);
    };

    var getWebhookConsumeExternalFields = function(webhookId) {
        IntegrationsService.getWebhookConsumeExternalFields(webhookId, { integration_id: $state.params.id }).then(function(response) {
            if(response && response.error) {
                $ioAlert.show('Error!', response.error, 'error');
            } else {
                $scope.webhookConsumeExternalFields = JSON.parse(response);
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    var addImportConfigure = function() {
        if (isNewImport) {
            var obj = {
                apply_client_integration_template: 1
            };
            IntegrationsService.importerConfiguration("POST", { 'integrationId': $state.params.id, configuration: JSON.stringify(obj) }).then(function(response) {
                if (response && response.importerConfiguration) {


                } else {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                }
            }, function(error) {
                console.log("Error retrieving configuration details");
            });
        } else {
            questions.apply_client_integration_template = 1;
            IntegrationsService.importerConfiguration("PUT", { 'id': configureId, 'integrationId': $state.params.id, configuration: JSON.stringify(questions) }).then(function(response) {
                if (response && response.importerConfiguration) {} else {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                }
            }, function(error) {
                console.log("Error retrieving configuration details");
            });
        }

    };

    //add an entity mapping
    $scope.addMapping = function(index, mapping, isCopy = false) {
        $scope.lockedButton = true;
        var data = {};
        if (mapping) {
            if (isCopy) {
                // Create a deep copy so modifications caused by copy function
                // will not change the content of the original mapping.
                data.mapping = JSON.parse(JSON.stringify(mapping));
                data.mapping.id = "";
                data.mapping.xref_value = "";
                data.mapping.xref_key = data.mapping.xref_key + " copy";
            } else {
                data.mapping = mapping;
            }
        }
        data.xrefTypes = $scope.xrefTypes;
        data.integration = $scope.integration;
        data.hasClient = $scope.hasClient;
        data.nonIOUser = $scope.nonIOUser;

        //show the modal
        showConnectionModal('addMapping', data).result.then(function(formObj) {
            if (isCopy) {
                formObj.new = true;
            }
            IntegrationsService.integrationXref(formObj.new ? 'POST' : 'PUT', formObj).then(function(data) {
                //modal data returned, now call create
                $scope.lockedButton = false;
                if (!data.hasOwnProperty('errors')) {
                    if (formObj.new) {
                        updateMappingList([data.integrationXref]);
                        // copy all the fields of the source mapping to the new mapping
                        if (isCopy && mapping.type_name === data.integrationXref.type_name) {
                            // get all the fields from the source mapping and the new mapping
                            let sourceTemplates = null;
                            let sourceMaprefs = null;
                            getMappingTemplates(mapping, true).then(function() {
                                sourceTemplates = mapping.templates;
                                sourceMaprefs = mapping.mapref;

                                let newMappingMaprefs = null;
                                let newMapping = data.integrationXref;
                                getMappingTemplates(newMapping, true).then(function() {
                                    let newMappingMaprefs = newMapping.mapref;

                                    // get internal field names and the corresponding ids
                                    const sourceMaprefLookup = sourceMaprefs.reduce((acc, { id, field_name }) => {
                                        acc[id] = field_name;
                                        return acc;
                                    }, {});
                                    const newMappingMaprefLookup = newMappingMaprefs.reduce((acc, { id, field_name }) => {
                                        acc[field_name] = id;
                                        return acc;
                                    }, {});

                                    // copy every template from source mapping to new mapping.
                                    for (const template of sourceTemplates) {
                                        const sourceFieldName = sourceMaprefLookup[template.field_id];
                                        // only copy if new mapping also has internal field with the same name.
                                        if (sourceFieldName && newMappingMaprefLookup[sourceFieldName]) {
                                            addNewTemplateWhenClone(newMapping, sourceFieldName, newMappingMaprefLookup[sourceFieldName], template);
                                        }
                                    }
                                }, function(error) {
                                    $ioAlert.show('Error!', 'Unable to create new mapping fields. Please refresh the page to try again', 'error');
                                });
                            }, function(error) {
                                $ioAlert.show('Error!', 'Unable to copy source mapping fields. Please refresh the page to try again', 'error');
                            });


                        }
                    } else {
                        $scope.mappings.splice(index, 1);
                        updateMappingList([data.integrationXref]);
                    }
                    if (parseInt(formObj.integrationTypeId) == 3) {
                        $scope.hasClient = true;
                        if (formObj.new) {
                            addImportConfigure();
                        }
                    }
                    $location.hash('bottom-scroll');
                    anchorSmoothScroll.scrollTo('bottom-scroll');
                    $timeout(function() {
                        $location.hash('');
                    }, 1000);
                    $ioAlert.show('', 'Mapping successfully added.', 'success');
                } else {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                }
            }, function(error) {
                $scope.lockedButton = false;
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }, function(cancel) {
            $scope.lockedButton = false;
        });
    };

    //delete an entity mapping
    $scope.deleteMapping = function(mappingId, name) {
        $scope.lockedButton = true;
        showConnectionModal('deleteMapping', {}).result.then(function() {
            //call the backend cascade delete
            IntegrationsService.integrationXref('DELETE', { id: $scope.mappings[mappingId].id }).then(function(data) {
                $scope.lockedButton = false;
                if (!data.hasOwnProperty('errors')) {
                    $scope.mappings.splice(mappingId, 1);
                    if (name == 'Client') {
                        $scope.hasClient = false;
                    }
                    $ioAlert.show('', 'Connection mappings successfully deleted.', 'success');
                } else {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                }
            }, function(error) {
                $scope.lockedButton = false;
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            })
        }, function(cancel) {
            $scope.lockedButton = false;
        });
    };

    function updateMappingList(mappings) {
        $scope.lockedButton = false;
        mappings.forEach(function(mapping) {
            var typeName = $scope.xrefTypes[mapping.type_id];
            var templateObj = { integrationName: $scope.integration.name };
            templateObj[typeName === 'Product' ? 'productId' : 'clusterId'] = mapping.xref_key;
            mapping.type = { name: typeName, id: mapping.xref_value };
            mapping.type_name = typeName.charAt(0).toUpperCase() + typeName.slice(1);
            mapping.dtaTypes = $scope.dataTypes;
            mapping.lookupTypes = ProductService.lookupTypes;
            mapping.disabled = false;

            //Render the mapping itself here to prevent heavy visual blocking
            $scope.mappings.push(mapping);
        });
    }
    $scope.addSalesforceConnection = function(isSalesForce) {
        $scope.lockedButton = true;
        if ($state.params.type == 'salesforce') {
            // TODO: Remove after TO-688 is tested and moved to production
            // var data = {
            //     "salesforceObj": salesforceObj
            // };
            // showIntegrationModal('salesforceConnectionForm', data).result.then(function(formObj) {
            //     $scope.lockedButton = false;
            //     getCredentials(1);
            // }, function(cancel) {
            //     $scope.lockedButton = false;
            // });
            $state.go('integrations.updateSalesforceIntegration', { "id": $state.params.id, "serviceConnectionId": salesforceObj.id });
        } else if (fileCredentailObj) {
            $state.go('integrations.updateFileIntegration', { "id": $state.params.id, "serviceConnectionId": fileCredentailObj.id });
        } else {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        }
    };

    $scope.configure = function() {
        $state.go('integrations.configure', {
            'id': $state.params.id,
            'type': $state.params.type
        });
    };

    $scope.activityLogs = function() {
        $state.go('integrations.activityLog', {
            'id': $state.params.id,
            'type': $state.params.type
        });
    };

    $scope.webhook = function() {
        var webhookType;
        if ($scope.integration.type_id == '4') {
            webhookType = 'publish';
        } else {
            webhookType = 'consume';
        }
        $state.go('integrations.webhook', {
            'id': $state.params.id,
            'webhookType': webhookType,
            'integration': $scope.integration
        });
    };

    $scope.refreshData = function() {
        if ($scope.integration && $scope.integration.client_only == '1') {
            IntegrationsService.refreshSalesforceAccounts({ 'integrationName': $scope.integration.name }).then(function(data) {
                if (data.imported_accounts) {
                    if (data.imported_accounts.status == 'success') {
                        if (data.imported_accounts.message) {
                            $ioAlert.show('', data.imported_accounts.message, 'success');
                        } else {
                            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                        }
                    } else if (data.imported_accounts.status == 'fail') {
                        $ioAlert.show('Error!', data.imported_accounts.message, 'error');
                    } else if (!data.imported_accounts.hasOwnProperty('errors')) {
                        $ioAlert.show('', 'Data Refreshed Successfully.', 'success');
                    } else {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    }
                } else {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                }

            }, function(error) {
                $scope.lockedButton = false;
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        } else {
            IntegrationsService.refreshSalesforce({ 'integrationName': $scope.integration.name }).then(function(data) {
                if (data.imported_opportunities) {
                    if (data.imported_opportunities.status == 'success') {
                        if (data.imported_opportunities.message) {
                            $ioAlert.show('', data.imported_opportunities.message, 'success');
                        } else {
                            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                        }
                    } else if (data.imported_opportunities.status == 'fail') {
                        $ioAlert.show('Error!', data.imported_opportunities.message, 'error');
                    } else if (!data.imported_opportunities.hasOwnProperty('errors')) {
                        $ioAlert.show('', 'Data Refreshed Successfully.', 'success');
                    } else {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    }
                } else {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                }

            }, function(error) {
                $scope.lockedButton = false;
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }

    };

    $scope.updateStatus = function(isActive) {
        const obj = {
            "id": $state.params.id,
            "active": isActive ? 1 : 0
        };
        IntegrationsService.toggleStatus(obj).then(function(data) {
            if (data) {
                $ioAlert.show('', 'Status updated successfully.', 'success');
            }
        }, function(error) {
            $scope.lockedButton = false;
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });

    };

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    function adjustStickyHeader() {
        var parentWidth = $(".nav-content").width();
        $("#header").width(parentWidth);
        var childHeight = $("#header").height();
        $(".nav-content").height(childHeight);
    }

    $(window).resize(
        function() {
            adjustStickyHeader();
        }
    )

    function init() {
        if ($state.params && $state.params.id) {
            if ($rs.userRole) {
                ClusterService.initCluster($rs.userRole, 'hidden');
            } else if ($rs.user && $rs.user.isIOAuthorized === false) {
                $scope.nonIOUser = true;
            }
            if ($state.params.type == 'salesforce') {
                $scope.showCredentials = true;
                $scope.isSalesForce = true;
            } else {
                $scope.isSalesForce = false;
                $scope.showCredentials = false;
            }
            if ($state.params.isSalesForce) {
                $scope.addSalesforceConnection();
            }
            getDataTypes();
            getLookupTypes();
            getIntegration();
            switch ($state.params.type) {
                case 'webhookPublish':
                    $scope.isWebhook = true;
                    $scope.webhookType = 'publish';
                    break;
                case 'webhookConsume':
                    $scope.isWebhook = true;
                    $scope.webhookType = 'consume';
                    break;
                default:
                    $scope.isWebhook = false;
            }
        } else {
            $state.go('integrations');
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        }
        getInstanceLockConfig();
        adjustStickyHeader();
    }

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
}

ConfigureImportController.$inject = ['$rootScope', '$scope', '$state', 'ClusterService', 'IntegrationsService', '$ioAlert', 'ioServiceConnectionsService', 'UserService', '$timeout', 'FormService'];

function ConfigureImportController($rs, $scope, $state, ClusterService, IntegrationsService, $ioAlert, ioServiceConnectionsService, UserService, $timeout, FormService) {

    $scope.questions = {};
    var isNew = true;
    var configureId;
    //$scope.saleforceObj = {};
    $scope.integrationType = $state.params.type;
    $scope.nonIOUser = false;
    //$scope.isConfigLoading = true;
    $scope.clusters = [];
    $scope.authTypes = [];
    $scope.authTypes = [
        { id: 'none', label: 'None' },
        { id: 'basic', label: 'Basic' },
        { id: 'oauth', label: 'OAuth 2.0' }
    ];
    $scope.disableBtnAction = false;
    $scope.productPackageEnabled = false;

    $scope.updateRadio = function(property, value) {
        $scope.questions[property] = value;
        if (property == 'new_client_business_unit' && value != 'specific_business_unit') {
            $scope.questions.clientBusinessUnit = "";
        }
    };

    $scope.navigateBack = function() {
        $state.go('integrations.mappings', {
            'id': $state.params.id,
            'type': $state.params.type
        });
    };

    $scope.addQuestion = function() {

        if ($scope.nonIOUser && $scope.integrationType == 'file') {
            var obj = {
                "new_client_business_unit": $scope.questions.new_client_business_unit,
                "business_unit_match_field": $scope.questions.business_unit_match_field,
                "client_match_field": $scope.questions.client_match_field,
                "client_group_fields": $scope.questions.client_group_fields
            };
            if ($scope.questions.external_cluster_id_field) {
                obj.external_cluster_id_field = $scope.questions.external_cluster_id_field;
            }
            if ($scope.questions.clientBusinessUnit) {
                obj.clientBusinessUnit = $scope.questions.clientBusinessUnit;
            }
            if($scope.questions.client_crm_id_field){
                obj.client_crm_id_field = $scope.questions.client_crm_id_field;
            }
            obj = JSON.stringify(obj);
        } else {
            var obj = JSON.stringify($scope.questions);
        }
        if (isNew) {
            IntegrationsService.importerConfiguration("POST", { 'integrationId': $state.params.id, configuration: obj }).then(function(response) {
                if (response && response.importerConfiguration) {
                    $ioAlert.show('', 'Added successfully', 'success');
                    $scope.navigateBack();
                } else {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                }
            }, function(error) {
                console.log("Error retrieving configuration details");
            });
        } else {
            IntegrationsService.importerConfiguration("PUT", { 'id': configureId, 'integrationId': $state.params.id, configuration: obj }).then(function(response) {
                if (response && response.importerConfiguration) {
                    $ioAlert.show('', 'Updated successfully successfully', 'success');
                    $scope.navigateBack();
                } else {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                }
            }, function(error) {
                console.log("Error retrieving configuration details");
            });
        }

    };

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    function getInstanceSettings() {
        let params = [
            "product_package_enabled",
        ];
        FormService.getInstanceSettingArray(params).then(function(data) {
            if (data && data.instance_settings) {
                const productPackageEnabled = data.instance_settings.product_package_enabled;
                $scope.productPackageEnabled = (productPackageEnabled === "1");
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong getting instance settings. Please refresh the page to try again', 'error');
        });
    }

    function adjustStickyHeader() {
        var parentWidth = $(".nav-content").width();
        $("#header").width(parentWidth);
        var childHeight = $("#header").height();
        $(".nav-content").height(childHeight);
    }

    $(window).resize(
        function() {
            adjustStickyHeader();
        }
    )

    function init() {
        if ($rs.userRole.permissions) {
            ClusterService.initCluster($rs.userRole, 'hidden').then(function() {
                $scope.clusters = ClusterService.clusters;
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        } else if ($rs.user && $rs.user.isIOAuthorized === false) {
            $scope.nonIOUser = true;
            ClusterService.getClustersForNonIO().then(function(data) {
                if (data && data[0]) {
                    $scope.clusters = data[0].clusters;
                } else {
                    $scope.clusters = [];
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            })
        }
        if ($state.params.id) {
            IntegrationsService.configurationForIntegration('GET', { 'integrationId': $state.params.id }).then(function(response) {
                if (response.importerConfiguration) {
                    isNew = false;
                    configureId = response.importerConfiguration.id;
                    $scope.questions = response.importerConfiguration.configuration;
                    if ($scope.integrationType == 'file' ||
                        $scope.integrationType == 'salesforce' ||
                        $scope.integrationType == 'webhookConsume') {
                        if ($scope.questions && !$scope.questions.hasOwnProperty('enable_client_group_creation')) {
                            $scope.questions.enable_client_group_creation = true;
                        }
                    }
                } else {
                    $scope.questions = {
                        "new_client_business_unit": "import_data_field",
                        "client_match_field": "crm_id"
                    };
                    if (!$scope.nonIOUser) {
                        $scope.questions.new_order_business_unit = "import_data_field";
                        $scope.questions.salesperson_match_field = "external_user_id";
                    }
                    if ($scope.integrationType == 'file' || $scope.integrationType == 'salesforce' || $scope.integrationType == 'webhookConsume') {
                        $scope.questions.business_unit_match_field = "name";
                        $scope.questions.enable_client_group_creation = true;
                    }
                    if ($scope.integrationType == 'file') {
                        $scope.questions.enable_fast_duplicate_filtering = false;
                        $scope.questions.enable_internal_identifiers = false;
                    }
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                $state.go('integrations');
            });

        } else {
            $state.go('integrations');
        }
        getInstanceLockConfig();
        adjustStickyHeader();
        getInstanceSettings();
    }
    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
}

FileIntegrationController.$inject = ['$rootScope', '$scope', '$state', 'ClusterService', 'IntegrationsService', '$ioAlert', 'ioServiceConnectionsService', 'UserService', 'WorkflowsService'];

function FileIntegrationController($rs, $scope, $state, ClusterService, IntegrationsService, $ioAlert, ioServiceConnectionsService, UserService, WorkflowsService) {
    var vm = this;
    vm.isNew = true;
    vm.serviceConnection = {};
    //vm.authTypes = ["FTP", "SFTP", "Google Drive", "Dropbox", "Manual"];
    // REMOVING GOOGLE DRIVE AND DROPBOX AUTH TYPES UNTIL OAUTH ISSUE IS FIXED
    vm.authTypes = ["FTP", "SFTP"];
    vm.formObj = {
        auth_type: "FTP"
    };
    vm.driveObj = {};
    vm.dropBoxObj = {};
    vm.dropBoxFileName = "";
    //$scope.dateTypes = ["dd-mm-yyyy", "mm-dd-yyyy", "yyyy-mm-dd", "yyyy-dd-mm", "yyyymmdd", "unixtime"];
    //$scope.businessUnitsArr = ["Account Owner", "Sales Person"];
    //$scope.clientsArr = angular.copy($scope.businessUnitsArr);
    //vm.fromIntegrations = true;
    vm.nameObj = {};
    vm.toggleAuthType = toggleAuthType;
    vm.onPicked = onPicked;
    vm.onCancel = onCancel;
    vm.onLoaded = onLoaded;
    vm.onDropboxSuccess = onDropboxSuccess;
    vm.onDropboxCancel = onDropboxCancel;
    vm.navigateBack = navigateBack;
    vm.updateCancelRadio = updateCancelRadio;
    vm.resetCancelForm = resetCancelForm;
    vm.hasIOAccess = true;
    vm.fileIntegrationAction = [];
    vm.formObj.cancelLogic = false;
     
     var getWorkflowActions = function() {
        WorkflowsService.getWorkflowActions().then(function(success) {
            vm.fileIntegrationAction = WorkflowsService.workflowActions;
            }, function(error) {
            console.log("error loading tasks list");
        });
    };
    //Toggle Auth Type Helper function
    function toggleAuthType(authType) {
        vm.formObj.auth_type = authType;
    }

    //Google drive helper function for picking files
    function onPicked(docs, accessToken) {
        vm.driveObj = {
            "auth_type": "GOOGLE_DRIVE",
            "access_token": accessToken,
            "fileName": docs[0].id
        };
    }

    //Google Drive Cancel Helper function
    function onCancel() {
        console.log('Google picker close/cancel!');
    }

    // Google Drive Helper function for loading
    function onLoaded() {
        console.log('Google Picker loaded!');
    }

    function onDropboxSuccess(file) {
        vm.dropBoxObj = {
            "auth_type": "DROPBOX",
            "fileId": file[0].id,
            "fileName": file[0].link
        };
        vm.dropBoxFileName = file[0].name;
    }

    function onDropboxCancel() {
        console.log('Dropbox close/cancel!');
    }

    function navigateBack() {
        if ($state.params.id) {
            $state.go('integrations.mappings', {
                'id': $state.params.id,
                'type': 'file'
            });
        } else {
            $state.go('integrations');
        }
    }
    function updateCancelRadio(value) {
        vm.formObj.cancelType = value;
            if (value != 'CUSTOM') {
            vm.formObj.cancelWorkflowAction = "";
        }
    };
    function resetCancelForm(){
        vm.formObj.cancelFileName = "";
        vm.formObj.cancelType = "LEGACY";
        vm.formObj.cancelWorkflowAction = "";
    }

    function getServiceConnection(serviceConnectionId) {
        ioServiceConnectionsService.getServiceConnection(serviceConnectionId).then(function(response) {
            vm.isNew = false;
            vm.serviceConnection = response.serviceConnection;
            if (response.serviceConnection.user_data) {
                vm.formObj = angular.fromJson(response.serviceConnection.user_data);
            }
        }, function(error) {
            console.log("Error get Service Connection");
        });
    }

    vm.addOrUpdateIntegration = function(integrationForm) {
        if (vm.isNew) {
            if (integrationForm.$valid) {
                if (vm.formObj.auth_type) {
                    if (vm.formObj.auth_type == "Google Drive" && Object.keys(vm.driveObj).length == 0) {
                        $ioAlert.show('Error!', 'Please pick at least one file from google drive', 'error');
                        return;
                    }
                    if (vm.formObj.auth_type == "Dropbox" && Object.keys(vm.dropBoxObj).length == 0) {
                        $ioAlert.show('Error!', 'Please pick at least one file from Dropbox', 'error');
                        return;
                    }
                    var obj = {
                        'name': vm.nameObj.name,
                        'typeId': '2',
                        "clientOnly": (vm.nameObj.clientOnly === true) ? 1 : 0
                    };
                    IntegrationsService.integration('POST', obj).then(function(data) {
                        if (!data.hasOwnProperty('errors')) {
                            var serviceObj = {};
                            switch (vm.formObj.auth_type) {
                                case 'Google Drive':
                                    serviceObj.serviceId = 7;
                                    serviceObj.userData = JSON.stringify(vm.driveObj);
                                    break;
                                case 'Dropbox':
                                    serviceObj.serviceId = 8;
                                    serviceObj.userData = JSON.stringify(vm.dropBoxObj);
                                    break;
                                default:
                                    serviceObj.serviceId = 5;
                                    serviceObj.userData = JSON.stringify(vm.formObj);
                            }
                            var integrationObj = {
                                "id": data.integration.id,
                                "name": data.integration.name,
                                "typeId": data.integration.type_id,
                                "clientOnly": data.integration.client_only
                            };
                            ioServiceConnectionsService.addServiceConnection(serviceObj).then(function(response) {
                                if (response.errors) {
                                    for (var i = 0, len = response.errors.length; i < len; i++) {
                                        $ioAlert.show('Error', response.errors[i]);
                                    }
                                } else if (response.serviceConnection) {
                                    integrationObj.serviceConnectionId = response.serviceConnection.id;
                                    IntegrationsService.integration('PUT', integrationObj).then(function(data) {
                                        if (vm.formObj.auth_type == "FTP") {
                                            $ioAlert.show('', "Integration added Successfully", "success");
                                            $state.go('integrations');
                                        } else {
                                            IntegrationsService.SaveOauth({ 'service_connection_id': data.service_connection_id }).then(function(data) {
                                                //Make an API call to update service connection
                                            }, function(error) {
                                                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                                            });
                                        }
                                    }, function(error) {
                                        console.log("Error updating integration");
                                    });
                                } else {
                                    $ioAlert.show('Error', "Error Adding Service Connection");
                                }

                            }, function(error) {
                                console.log("Error Adding Service Connection");
                            });
                        } else {
                            $ioAlert.show('Error!', JSON.stringify(data.errors), 'error');
                        }
                    }, function(error) {
                        vm.lockedButton = false;
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    })
                } else {
                    $ioAlert.show('Error!', 'Please select delivery type', 'error');
                }
            } else {
                $ioAlert.show('Error!', 'Please fill the required fields', 'error');
            }
        } else {
            // Service id is 5 until we implement Google Drive and dropbox
            const serviceObj = {
                "id": vm.serviceConnection.id,
                "serviceId": 5,
                "userData": JSON.stringify(vm.formObj)
            };
            ioServiceConnectionsService.updateServiceConnection(serviceObj).then(function(response) {
                if (response.errors) {
                    for (var i = 0, len = response.errors.length; i < len; i++) {
                        $ioAlert.show('Error', response.errors[i]);
                    }
                } else if (response.serviceConnection) {
                    $ioAlert.show('', "Updated Successfully", "success");
                    $state.go('integrations.mappings', {
                        'id': $state.params.id,
                        'type': 'file'
                    });
                } else {
                    $ioAlert.show('Error', "Error Adding Service Connection");
                }
            }, function(error) {
                console.log("Error Adding Service Connection");
            });
        }
    };

    function adjustStickyHeader() {
        var parentWidth = $(".nav-content").width();
        $("#header").width(parentWidth);
        var childHeight = $("#header").height();
        $(".nav-content").height(childHeight);
    }

    $(window).resize(
        function() {
            adjustStickyHeader();
        }
    )

    function init() {
        getWorkflowActions();
        adjustStickyHeader();
        if ($rs.userRole) {
            ClusterService.initCluster($rs.userRole, 'hidden');
        } else if ($rs.user.isIOAuthorized === false) {
            vm.nameObj = {
                "clientOnly": true
            };
            vm.hasIOAccess = false;
        }
        if ($state.params.serviceConnectionId) {
            getServiceConnection($state.params.serviceConnectionId);
        }
    }

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
}

SalesforceIntegrationController.$inject = ['$rootScope', '$scope', '$state', 'ClusterService', 'IntegrationsService', '$ioAlert', 'ioServiceConnectionsService', 'UserService'];

function SalesforceIntegrationController($rs, $scope, $state, ClusterService, IntegrationsService, $ioAlert, ioServiceConnectionsService, UserService) {
    var vm = this;
    vm.isNew = true;
    vm.nameObj = {};
    vm.salesforceObj = {};
    vm.navigateBack = navigateBack;
    vm.saveSalesforceIntegration = saveSalesforceIntegration;

    function navigateBack() {
        if ($state.params.id) {
            $state.go('integrations.mappings', {
                'id': $state.params.id,
                'type': 'salesforce'
            });
        } else {
            $state.go('integrations');
        }
    };

    /*
     * Get the existing credetials for existing salesforce connecion
     */
    function getServiceConnection(serviceConnectionId) {
        ioServiceConnectionsService.getServiceConnection(serviceConnectionId).then(function(response) {
            vm.isNew = false;
            vm.serviceConnection = response.serviceConnection;
            if (response.serviceConnection.user_data) {
                vm.salesforceObj = angular.fromJson(response.serviceConnection.user_data);
            }
        }, function(error) {
            console.log("Error get Service Connection");
        });
    }

    /*
     * Add or update salesforce credentials
     */
    function saveSalesforceIntegration(integrationForm) {
        if (vm.isNew) {
            if (integrationForm.$valid) {
                var obj = {
                    'name': vm.nameObj.name,
                    'typeId': '3',
                    "clientOnly": (vm.nameObj.clientOnly === true) ? 1 : 0
                };
                IntegrationsService.integration('POST', obj).then(function(integrationResponce) {
                    if (!integrationResponce.hasOwnProperty('errors')) {
                        var integrationObj = {
                            "id": integrationResponce.integration.id,
                            "name": integrationResponce.integration.name,
                            "typeId": integrationResponce.integration.type_id,
                            "clientOnly": integrationResponce.integration.client_only
                        };
                        var serviceObj = {
                            "serviceId": 1,
                        };
                        serviceObj.userData = JSON.stringify(vm.salesforceObj);
                        ioServiceConnectionsService.addServiceConnection(serviceObj).then(function(response) {
                            if (response.errors) {
                                for (var i = 0, len = response.errors.length; i < len; i++) {
                                    $ioAlert.show('Error', response.errors[i]);
                                }
                            } else if (response.serviceConnection) {
                                integrationObj.serviceConnectionId = response.serviceConnection.id;
                                IntegrationsService.integration('PUT', integrationObj).then(function(data) {
                                    if (data.errors) {
                                        for (var i = 0, len = data.errors.length; i < len; i++) {
                                            $ioAlert.show('Error', data.errors[i]);
                                        }
                                    } else {
                                        $ioAlert.show('', "Integration created successfully", "success");
                                        $state.go('integrations.configure', {
                                            "id": integrationObj.id,
                                            "type": 'salesforce',
                                            "isSalesForce": true
                                        });
                                    }
                                }, function(error) {
                                    console.log("Error updating integration");
                                });
                            } else {
                                $ioAlert.show('Error', "Error Adding Service Connection");
                            }
                        }, function(error) {
                            console.log("Error Adding Service Connection");
                        });
                    } else {
                        $ioAlert.show('Error!', JSON.stringify(integrationResponce.errors), 'error');
                    }
                }, function(error) {
                    //vm.lockedButton = false;
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                })
            }
        } else {
            var serviceObj = {
                "id": vm.serviceConnection.id,
                "serviceId": 1,
                "userData": JSON.stringify(vm.salesforceObj)
            };
            ioServiceConnectionsService.updateServiceConnection(serviceObj).then(function(response) {
                if (response.errors) {
                    for (var i = 0, len = response.errors.length; i < len; i++) {
                        $ioAlert.show('Error', response.errors[i]);
                    }
                } else if (response.serviceConnection) {
                    $ioAlert.show('', "Updated Successfully", "success");
                    $state.go('integrations.mappings', {
                        'id': $state.params.id,
                        'type': 'salesforce'
                    });
                } else {
                    $ioAlert.show('Error', "Error Adding Service Connection");
                }
            }, function(error) {
                console.log("Error Adding Service Connection");
            });
        }
    }

    function adjustStickyHeader() {
        var parentWidth = $(".nav-content").width();
        $("#header").width(parentWidth);
        var childHeight = $("#header").height();
        $(".nav-content").height(childHeight);
    }

    $(window).resize(
        function() {
            adjustStickyHeader();
        }
    )

    function init() {
        adjustStickyHeader();
        if ($rs.userRole) {
            ClusterService.initCluster($rs.userRole, 'hidden');
        } else if ($rs.user.isIOAuthorized === false) {
            vm.nameObj = {
                "clientOnly": true
            };
            $scope.hasIOAccess = false;
        }
        if ($state.params.serviceConnectionId) {
            getServiceConnection($state.params.serviceConnectionId);
        }
    }

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
}

IntegrationActivityLogController.$inject = ['$rootScope', '$scope', '$state', 'IntegrationsService', '$ioAlert', '$timeout'];

function IntegrationActivityLogController($rs, $scope, $state, IntegrationsService, $ioAlert, $timeout) {
    $scope.IntegrationActivityLogList = {};

    $scope.detailedActivityView = false;
    $scope.viewActivity = false;

    /*
     * Handle views switching between summary and detailed view
     */
    $scope.switchToViews = function(ev, text) {
        ev.preventDefault();
        if (text == 'detailed_view') {
            $scope.detailedActivityView = true;
        } else {
            $scope.detailedActivityView = false;

        }
        resetActivityView();
        $scope.getActivityLogList();
    };

    /*
     *  Handle clear the data of search and date filter
     */
    $scope.clearFilters = function() {
        resetActivityView();
        $scope.getActivityLogList();
    }

    $scope.dateFilters = [{
        "value": '',
        'name': ''
    }, {
        "value": 'eq',
        'name': '='
    }, {
        "value": 'gt',
        'name': '>'
    }, {
        "value": 'ge',
        'name': '>='
    }, {
        "value": 'le',
        'name': '<='
    }, {
        "value": 'lt',
        'name': '<'
    }, {
        "value": 'bw',
        'name': 'start to end'
    }];

    /*
     * Handle page activity request paramerters
     */
    var resetActivityView = () => {
        $scope.pageObj = {
            perPageOptions: [10, 25, 50, 100],
            perPage: 25,
            search: '',
            currentPage: 1,
            totalCount: 0,
            startIndex: 1,
            endIndex: 1,
            maxSize: 2,
            orderType: '',
            reverse: false,
            dateFilterBy: 'eq',
            from: '',
            status: ''
        };
        if ($scope.detailedActivityView) {
            $scope.pageObj.orderBy = 'activity_id';
            $scope.pageObj.status = 'all';
        } else {
            $scope.pageObj.orderBy = 'start_time';
            $scope.pageObj.status = 'all';
        }
    }

    /*
     * Handle counts for indexes
     */
    var calculate = function(data) {
        $rs.loadingInProgress = false;
        $scope.pageObj.totalCount = data.total_count;
        $scope.pageObj.currentPage = data.page;

        $scope.pageObj.startIndex = Math.ceil((($scope.pageObj.currentPage - 1) * $scope.pageObj.perPage) + 1);
        $scope.pageObj.endIndex = Math.min($scope.pageObj.currentPage * $scope.pageObj.perPage);
        if ($scope.pageObj.totalCount != 0 && $scope.pageObj.endIndex > $scope.pageObj.totalCount) {
            $scope.pageObj.endIndex = $scope.pageObj.totalCount;
        }
    };

    /*
     * GET all activity log batches
     */
    $scope.getActivityLogList = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Activity Logs";
        var params = {
            "integrationId": $scope.IntegrationId,
            "orderBy": $scope.pageObj.orderBy,
            "page": $scope.pageObj.currentPage,
            "perPage": $scope.pageObj.perPage,
            "status": $scope.pageObj.status,
            "dateFilterBy": $scope.pageObj.dateFilterBy,
            "from": '',
            "search": '',
            "orderType": ''
        }

        if ($scope.pageObj.from) {
            params.from = new Date($scope.pageObj.from).toLocaleDateString();
        }

        if ($scope.pageObj.to) {
            params.to = new Date($scope.pageObj.to).toLocaleDateString();
        }

        if ($scope.pageObj.reverse == false) {
            params.orderType = "desc";
        } else {
            params.orderType = "asc";
        }

        if ($scope.detailedActivityView) {
            if ($scope.pageObj.search) {
                params.search = $scope.pageObj.search;
                searchDetailIntegrationActivity(params);
            } else {
                detailedViewActivity(params);
            }
        } else {
            if ($scope.pageObj.search) {
                params.search = $scope.pageObj.search;
                IntegrationsService.SearchIntegrationActivityLogs(params).then(function(data) {
                    $scope.IntegrationActivityLogList = data;
                    calculate($scope.IntegrationActivityLogList);
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here: ' + error, 'error');
                    $rs.loadingInProgress = false;
                });
            } else {
                IntegrationsService.getIntegrationActivityLogs(params).then(function(data) {
                    $scope.IntegrationActivityLogList = data;
                    calculate($scope.IntegrationActivityLogList);
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here: ' + error, 'error');
                    $rs.loadingInProgress = false;
                });
            }
        }
    }

    /*
     * Handle search detailed view integration activity logs service call
     */
    var searchDetailIntegrationActivity = function(params) {
        IntegrationsService.searchDetailIntegrationActivityLogs(params).then(function(data) {
            _.each(data.integrationActivityLogs, function(log) {
                if (log.failure_reason && _.isArray(log.failure_reason.details)) {
                    log.failure_reason.details = log.failure_reason.details.join(' ');
                }
            });
            $scope.integrationActivityDetails = data;
            calculate($scope.integrationActivityDetails);
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here: ' + error, 'error');
            $rs.loadingInProgress = false;
        });
    }

    /*
     * Handle detailed view integration activity logs service call
     */
    var detailedViewActivity = function(params) {
        IntegrationsService.getDetailedIntegrationActivityLogs(params).then(function(data) {
            _.each(data.integrationActivityLogs, function(log) {
                if (log.failure_reason && _.isArray(log.failure_reason.details)) {
                    log.failure_reason.details = log.failure_reason.details.join(' ');
                }
            });
            $scope.integrationActivityDetails = data;
            calculate($scope.integrationActivityDetails);
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here: ' + error, 'error');
            $rs.loadingInProgress = false;
        });
    }

    /*
     *   Handle download the activity objects as a csv file
     */
    $scope.download_csv = function(batch_log_id, batch_id) {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Activity Logs";
        var params = {
            "integrationId": $scope.IntegrationId,
            "batchId": batch_id,
            "batchLogId": batch_log_id,
            "page": $scope.pageObj.currentPage,
            "perPage": $scope.pageObj.perPage,
        }
        IntegrationsService.getActivityLogCSV(params).then(function(data) {
            var hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(data);
            hiddenElement.target = '_blank';
            hiddenElement.download = 'activityLog.csv';
            hiddenElement.click();
            $rs.loadingInProgress = false;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here: ' + JSON.stringify(error), 'error');
        });
    }

    /*
     *   Handle back navigation to mappings
     */
    $scope.navigateBack = function() {
        $state.go('integrations.mappings', {
            'id': $state.params.id,
            'type': $state.params.type
        });
    };

    /*
     * Handle view switching variables
     */
    $scope.navigateBackToDetailView = function() {
        $scope.viewActivity = false;
        $scope.detailedActivityView = true;
    }

    /*
     *   Handle view navigation to activity result view
     */
    $scope.navigateToViewResults = function(batch_log_id, batch_id) {
        if (batch_log_id) {
            $state.go('integrations.activityResultView', {
                'id': $scope.IntegrationId,
                'batch_log_id': batch_log_id,
                'batch_id': batch_id,
                'type': $scope.type
            });
        } else {
            $ioAlert.show('Error!', 'batch_id is null.', 'error');
        }
    }

    /*
     *   Handle enabling activity view tree strecture
     */
    $scope.enableActivityView = function(activityData) {
        if (activityData.activity) {
            $scope.viewActivity = true;
            $scope.integrationActivity = activityData;
            $timeout(function() {
                $rs.$broadcast('ActivityLoaded');
            });
        } else {
            $ioAlert.show('Error!', 'activity is null.', 'error');
        }
    }

    function adjustStickyHeader() {
        var parentWidth = $(".nav-content").width();
        $("#header").width(parentWidth);
        var childHeight = $("#header").height();
        $(".nav-content").height(childHeight);
    }

    $(window).resize(
        function() {
            adjustStickyHeader();
        }
    )

    var init = function() {
        $scope.IntegrationId = $state.params.id;
        $scope.type = $state.params.type;
        resetActivityView();
        $scope.getActivityLogList();
        adjustStickyHeader();
    };

    init();
}

WebhookController.$inject = ['$rootScope', 'UserService', 'ClusterService', 'IntegrationsService', '$ioAlert', '$state', 'AppConfig', '$http', '$location'];

function WebhookController($rs, UserService, ClusterService, IntegrationsService, $ioAlert, $state, AppConfig, $http, $location) {
    var vm = this;
    vm.webhookObj = {};
    vm.authInfo = {};
    vm.authTypes = [];
    vm.navigateBack = navigateBack;
    vm.saveWebhook = saveWebhook;
    vm.testWebhookConsumeURL = testWebhookConsumeURL;
    vm.events = [];
    vm.entities = [];
    vm.methodTypes = ["POST", "GET", "DELETE", "PUT"];
    vm.webhookSubscriptions = [{
        "isNew": true
    }];
    vm.addSubscriptionEntity = addSubscriptionEntity;
    vm.addSubscriptionEntityOnForm = addSubscriptionEntityOnForm;
    vm.isNew = true;
    vm.isWebhookConsume = false;
    var subsId, webhookId;
    vm.webhookConsumeURL = "";
    vm.showWebhookConsumeResult = false;

    const webhookURL = "/server/api/webhook/catch/";

    // Get Integration if the page is reloaded
    function getIntegration() {
        IntegrationsService.integration('GET', { id: $state.params.id }).then(function(data) {
            if (data && data.integration) {
                vm.webhookObj.name = data.integration.name;
                vm.webhookObj.typeId = data.integration.type_id;
                if (data.integration.type_id == "5") {
                    vm.isWebhookConsume = true;
                    if (data.integration.webhook_id) {
                        webhookId = data.integration.webhook_id;
                        vm.webhookConsumeURL = $location.$$protocol + "://" + $location.$$host + webhookURL + webhookId;
                    } else {
                        getWebhookUrl();
                    }
                }
            } else {
                $ioAlert.show('Error!', 'Integration not found. Please try again', 'error');
            }

        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    function getWebhookSub() {
        IntegrationsService.getWebhookForIntegration({ 'integrationId': $state.params.id }).then(function(data) {
            if (data && data.id) {
                vm.isNew = false;
                subsId = data.id;
                if (data.additional_info) {
                    vm.webhookObj = {
                        "name": data.name,
                        "url": data.additional_info.url,
                        "methodType": data.additional_info.method_type,
                        "authType": data.additional_info.type
                    };

                    if (data.additional_info.includeLineItems) {
                        vm.webhookObj.includeLineItems = true;
                    }

                    if (data.additional_info.includeFlights) {
                        vm.webhookObj.includeFlights = true;
                    }

                    vm.authInfo = data.additional_info.auth_info;
                }
                getSubscriptionEntity();
            } else {
                vm.isNew = true;
            }
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    function getSubscriptionEntity() {
        IntegrationsService.getWebhookSubsEntities({ 'id': subsId }).then(function(data) {
            if (data && data.length) {
                _.each(data, function(entity) {
                    vm.webhookSubscriptions.unshift({
                        "id": entity.id,
                        "event_name": entity.event_name,
                        "entity_type": entity.entity_type,
                        "isNew": false
                    });
                });
            }
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    function getAuthTypes() {
        IntegrationsService.getAuthTypes().then(function(data) {
            vm.authTypes = data;
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    function getEventNames() {
        IntegrationsService.getEventNames().then(function(data) {
            vm.events = data;
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    function getEntityTypes() {
        IntegrationsService.getEntityTypes().then(function(data) {
            vm.entities = data;
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }


    /*
     * Update Subscription entity when webhook is updated
     */
    function updateSubscriptionEntity(webhook, isLast) {
        if (webhook && webhook.entity_type && webhook.event_name) {
            var obj = {
                "id": webhook.id,
                "webhookSubscriptionId": subsId,
                "entityType": webhook.entity_type,
                "eventName": webhook.event_name,
                "additionalInfo": {
                    "url": vm.webhookObj.url,
                    "method_type": vm.webhookObj.methodType,
                    "type": vm.webhookObj.authType,
                    "auth_info": vm.authInfo
                }
            };
            obj.additionalInfo = JSON.stringify(obj.additionalInfo);
            IntegrationsService.updateWebhookEntity(obj).then(function (data) {
                if (isLast) {
                    $ioAlert.show('', 'Webhook Subscription Entity updated successfully', 'success');
                    $state.go('integrations');
                }
            }, function (error) {
                $ioAlert.show('Error!', 'Failed to update an entity ' + webhook.entity_type + " " + webhook.event_name, 'error');
            });
        } else if (webhook && (!webhook.entity_type || !webhook.event_name)) {
            var obj = {"id": webhook.id};
            IntegrationsService.deleteWebhookEntity(obj).then(function (data) {
                if (isLast) {
                    $ioAlert.show('', 'Webhook Subscription Entity deleted successfully', 'success');
                    $state.go('integrations');
                }
            }, function (error) {
                $ioAlert.show('Error!', 'Failed to delete an entity', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'Please select event name and entity type', 'error');
        }
    }

    /*
     * Add Subscription entity
     */
    function addSubscriptionEntity(webhook, isLast) {
        if (webhook && webhook.entity_type && webhook.event_name) {
            var obj = {
                "webhookSubscriptionId": subsId,
                "entityType": webhook.entity_type,
                "eventName": webhook.event_name
            };
            obj.additionalInfo = JSON.stringify(obj.additionalInfo);
            IntegrationsService.saveWebhookEntity(obj).then(function(data) {
                if (isLast) {
                    $ioAlert.show('', 'Webhook Subscription Entity saved successfully', 'success');
                    $state.go('integrations');
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        } else {
            $ioAlert.show('Error!', 'Please select event name and entity type', 'error');
        }

    }

    /*
     * Add Subscription entity on the form not database
     */
    function addSubscriptionEntityOnForm(webhook) {
        if (webhook && webhook.entity_type && webhook.event_name) {
            webhook.isNew = false;
            vm.webhookSubscriptions.push({"isNew": true});
        } else {
            $ioAlert.show('Error!', 'Please select event name and entity type to add new event', 'error');
        }
    }

    function navigateBack() {
        $state.go('integrations.mappings', {
            'id': $state.params.id,
            'type': (vm.isWebhookConsume === true) ? 'webhookConsume' : 'webhookPublish'
        });
    }

    function validateAuthInfo(authType, authInfo) {
        if (authType === 'None') {
            return true;
        } else if (!authInfo) {
            return false;
        }
        switch (authType) {
            case 'Basic':
                return (authInfo.username && authInfo.password);
            case 'OAuth 2.0':
                return (authInfo.clientId && authInfo.clientSecret && authInfo.tokenUrl);
            case 'API Key':
                return (authInfo.api_key);
            case 'OAuth 2 - Refresh Token':
                return (authInfo.clientId && authInfo.refreshToken && authInfo.tokenUrl);
        }
    }

    // Save/Update Webhook
    function saveWebhook(webhookForm) {
        if (webhookForm.$valid) {
            if (!validateAuthInfo(vm.webhookObj.authType, vm.authInfo)) {
                $ioAlert.show('Error!', 'Please fill in the required authentication information', 'error');
                return;
            }

            let validSubscription = null;
            _.each(vm.webhookSubscriptions, function(subscription) {
                if (subscription && subscription.entity_type && subscription.event_name) {
                    validSubscription = subscription;
                    return;
                }
            });
            if (!validSubscription) {
                $ioAlert.show('Error!', 'No valid event selected, select event name and entity type', 'error');
                return;
            }

            let obj = {
                "name": vm.webhookObj.name,
                "integrationId": $state.params.id,
                "additionalInfo": {
                    "url": vm.webhookObj.url,
                    "method_type": vm.webhookObj.methodType,
                    "type": vm.webhookObj.authType,
                    "auth_info": vm.authInfo
                }
            };

            if (vm.webhookObj.includeLineItems) {
                obj.additionalInfo.includeLineItems = true;
            }

            if (vm.webhookObj.includeFlights) {
                obj.additionalInfo.includeFlights = true;
            }

            obj.additionalInfo = JSON.stringify(obj.additionalInfo);

            if (vm.isNew) {
                IntegrationsService.saveWebhook(obj).then(function(data) {
                    if (data && data.id) {
                        subsId = data.id;
                        addSubscriptionEntity(validSubscription, true);
                    }
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            } else {
                obj.id = parseInt(subsId);
                IntegrationsService.updateWebhook(obj).then(function(data) {
                    if (data && data.id) {
                        let isLastIndex = false;
                        _.each(vm.webhookSubscriptions, function(subscription, index) {
                            if (index === vm.webhookSubscriptions.length - 2) {
                                isLastIndex = true;
                            }
                            if (subscription.id) {
                                updateSubscriptionEntity(subscription, isLastIndex);
                            } else if (subscription && subscription.entity_type && subscription.event_name) {
                                addSubscriptionEntity(subscription, isLastIndex);
                            }
                        });
                    }
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            }
        } else {
            $ioAlert.show('Error!', 'Please fill in the required fields', 'error');
        }
    }

    /*
     * Get Webhook url for Integration type consume
     */
    function getWebhookUrl() {
        IntegrationsService.webhookUrl($state.params.id).then(function(data) {
            if (data.url) {
                vm.webhookConsumeURL = data.url;
                var splitArr = data.url.split('/');
                webhookId = splitArr[splitArr.length - 1];
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    /*
     * Test webhook consume using $http instead of restangular as we need to send the data as text/plain
     */
    function testWebhookConsumeURL() {
        vm.loadingInProgress = true;
        $http({
            method: 'POST',
            url: AppConfig.IO_API_URL + 'webhookConsume/testConnection/' + webhookId + '?integration_id=' + $state.params.id,
            headers: {
                'Content-Type': 'text/plain'
            },
            data: vm.webhookJson
        }).then(function successCallback(response) {
            if (response && response.data && response.data.error) {
                $ioAlert.show('Error!', 'Error parsing JSON data', 'error');
            } else if (response && response.data && response.data.external_fields) {
                $ioAlert.show('', 'Test Successfull', 'success');
                vm.testResult = response.data.external_fields;
                vm.showWebhookConsumeResult = true;
            }
            vm.loadingInProgress = false;
        }, function errorCallback(response) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    vm.gotoConfigurePage = function() {
        $state.go('integrations.configure', {
            'id': $state.params.id,
            'type': (vm.isWebhookConsume === true) ? 'webhookConsume' : 'webhookPublish'
        });
    }

    /*
     * Helper function for Copy to clipboard
     */
    vm.copyToClipboard = function(eleVal) {
        var aux = document.createElement("input");
        aux.setAttribute("value", eleVal);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
        $ioAlert.show('', 'Copied successfully', 'success');
    }

    function adjustStickyHeader() {
        var parentWidth = $(".nav-content").width();
        $("#header").width(parentWidth);
        var childHeight = $("#header").height();
        $(".nav-content").height(childHeight);
    }

    $(window).resize(
        function() {
            adjustStickyHeader();
        }
    )

    function init() {
        if ($rs.userRole) {
            ClusterService.initCluster($rs.userRole, 'hidden');
        }
        if ($state.params && $state.params.integration) {
            vm.webhookObj = {
                "name": $state.params.integration.name
            }
            if ($state.params.integration.type_id == "5") {
                vm.isWebhookConsume = true;
            }
            if ($state.params && $state.params.webhookType == 'consume') {
                if ($state.params.integration.webhook_id) {
                    webhookId = $state.params.integration.webhook_id;
                    vm.webhookConsumeURL = $location.$$protocol + "://" + $location.$$host + webhookURL + webhookId;
                } else {
                    getWebhookUrl();
                }
            }
        } else {
            getIntegration();
        }
        vm.webhookType = $state.params.webhookType;
        adjustStickyHeader();
        if ($state.params && $state.params.webhookType == 'publish') {
            getWebhookSub();
            getAuthTypes();
            getEventNames();
            getEntityTypes();
        }


    }
    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
}

ActivityLogResultViewController.$inject = ['$rootScope', '$scope', '$state', 'ClusterService', 'IntegrationsService', '$timeout', '$ioAlert'];

function ActivityLogResultViewController($rs, $scope, $state, ClusterService, IntegrationsService, $timeout, $ioAlert) {

    $scope.activityLogResultView = true;
    $scope.integrationActivityDetails = {};

    /*
     * Handle page activity log result request paramerters
     */
    var resetActivityResultView = () => {
        $scope.pageObj = {
            perPageOptions: [10, 25, 50, 100],
            perPage: 25,
            search: '',
            currentPage: 1,
            totalCount: 0,
            startIndex: 1,
            endIndex: 1,
            maxSize: 2,
            orderType: '',
            reverse: false,
            dateFilterBy: '',
            from: '',
            status: 'all',
            orderBy: 'activity_id',
        };
    }

    /*
     *  Handle clear the data of search and date filter
     */
    $scope.clearFilters = function() {
        resetActivityResultView();
        $scope.getActivityLogResults();
    }


    /*
     * Handle counts for indexes
     */
    var calculate = function(data) {
        $rs.loadingInProgress = false;
        $scope.pageObj.totalCount = data.total_count;
        $scope.pageObj.currentPage = data.page;

        $scope.pageObj.startIndex = Math.ceil((($scope.pageObj.currentPage - 1) * $scope.pageObj.perPage) + 1);
        $scope.pageObj.endIndex = Math.min($scope.pageObj.currentPage * $scope.pageObj.perPage);
        if ($scope.pageObj.totalCount != 0 && $scope.pageObj.endIndex > $scope.pageObj.totalCount) {
            $scope.pageObj.endIndex = $scope.pageObj.totalCount;
        }
    };

    /*
     * GET all activity log results
     */
    $scope.getActivityLogResults = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Activity Logs Results";
        var params = {
            "integrationId": $scope.IntegrationId,
            "batchLogId": $scope.batch_log_id,
            "page": $scope.pageObj.currentPage,
            "perPage": $scope.pageObj.perPage,
            "status": $scope.pageObj.status,
            "dateFilterBy": '',
            "from": '',
            "search": $scope.pageObj.search,
            'orderBy': $scope.pageObj.orderBy
        }

        if ($scope.pageObj.reverse == false) {
            params.orderType = "desc";
        } else {
            params.orderType = "asc";
        }

        if ($scope.pageObj.search) {
            params.search = $scope.pageObj.search;
            IntegrationsService.SearchIntegrationActivityLogs(params).then(function(data) {
                _.each(data.integrationActivityLogs, function(log) {
                    if (log.failure_reason && _.isArray(log.failure_reason.details)) {
                        log.failure_reason.details = log.failure_reason.details.join(' ');
                    }
                });
                $scope.integrationActivityDetails = data;
                calculate(data);
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here: ' + error, 'error');
                $rs.loadingInProgress = false;
            });
        } else {
            IntegrationsService.getIntegrationActivityLogs(params).then(function(data) {
                _.each(data.integrationActivityLogs, function(log) {
                    if (log.failure_reason && _.isArray(log.failure_reason.details)) {
                        log.failure_reason.details = log.failure_reason.details.join(' ');
                    }
                });
                $scope.integrationActivityDetails = data;
                calculate(data);
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here: ' + error, 'error');
                $rs.loadingInProgress = false;
            });
        }
    }

    /*
     *   Handle back navigation to activity logs
     */
    $scope.navigateBack = function(pageFrom) {
        if (pageFrom == 'activityResult') {
            $state.go('integrations.activityLog', {
                'id': $scope.IntegrationId,
                'type': $state.params.type
            });
        } else {
            $scope.activityLogResultView = true;
        }
    };

    /*
     *   Handle enabling activity view tree strecture
     */
    $scope.enableActivityView = function(activityData) {
        if (activityData.activity) {
            $scope.activityLogResultView = false;
            $scope.integrationActivity = activityData;
        } else {
            $ioAlert.show('Error!', 'activity is null.', 'error');
        }
    }

    function adjustStickyHeader() {
        var parentWidth = $(".nav-content").width();
        $("#header").width(parentWidth);
        var childHeight = $("#header").height();
        $(".nav-content").height(childHeight);
    }

    $(window).resize(
        function() {
            adjustStickyHeader();
        }
    )


    var init = function() {
        $scope.IntegrationId = $state.params.id;
        $scope.batch_log_id = $state.params.batch_log_id;
        $scope.batch_id = $state.params.batch_id;
        resetActivityResultView();
        $scope.getActivityLogResults();
        adjustStickyHeader();
    };

    init();
}